// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../modules/actions';

type Props = {
	match: Object,
	setSelectedLeague: Function
};

class SetSelectedLeagueComponent extends React.Component<Props> {
	componentDidMount() {
		const {
			match: { params },
			setSelectedLeague
		} = this.props;

		if (params && params.league_id) {
			setSelectedLeague(params.league_id);
		}
	}

	componentDidUpdate(prevProps) {
		const {
			match: { params },
			setSelectedLeague
		} = this.props;

		if (params.league_id !== prevProps.match.params.league_id) {
			setSelectedLeague(params.league_id);
		}
	}

	render() {
		return null;
	}
}

const mapStateToProps = null;

const mapDispatchToProps = ({
	setSelectedLeague: actions.uiSelectedLeague.setSelectedLeague
});

export const SetSelectedLeague = connect(
	mapStateToProps,
	mapDispatchToProps,
)(SetSelectedLeagueComponent);

export default SetSelectedLeague;


// WEBPACK FOOTER //
// ./src/components/utils/SetSelectedLeague/index.js